:host {
  display: block;
  line-height: initial;
  & > * {
    &:nth-child(2) {
      margin-bottom: 8px;
    }
  }
}

.circles {
  display: flex;
  flex-wrap: wrap;
  align-items: center;

  input {
    display: none;
  }

  a {
    text-decoration: none;

    &.checked .circle {
      color: white;
      font-family: var(--primary-icon-font);

      &:before {
        content: '\e814';
        position: relative;
      }
    }

    &.checked .multi li:nth-child(1) {
      color: white;
      font-family: var(--primary-icon-font);

      &:before {
        content: '\e814';
        position: relative;
      }
    }
  }

  .circle {
    cursor: pointer;
    background-color: var(--color);
    border-radius: 50%;
    vertical-align: middle;
    box-shadow: 0 0px 10px 0 #c4c4c4;

    &.multi-rainbow {
      background: -webkit-linear-gradient(0deg, #f06131, #ffc848 50%, #00b200);
      background: -moz-linear-gradient(0deg, #f06131, #ffc848 50%, #00b200);
      background: linear-gradient(0deg, #f06131, #ffc848 50%, #00b200);
    }
  }

  .multi {
    list-style: none;
    padding: 0;
    margin: 0;
    cursor: pointer;
    border-radius: 50%;
    overflow: hidden;
    box-shadow: 0 0px 10px 0 #ebebeb;

    li {
      width: var(--width);
      height: 100%;
      float: left;
      background-color: var(--color);
    }
  }

  input:checked + .circle {
    color: white;
    font-family: var(--primary-icon-font);

    &.darkColor {
      color: black;
    }

    &:before {
      content: '\e814';
      position: relative;
    }
  }

  input:checked + .multi li:nth-child(1) {
    color: white;
    font-family: var(--primary-icon-font);

    &:before {
      content: '\e814';
      position: relative;
    }
  }

  .additional-colors {
    font-family: var(--primary-font);
    font-weight: var(--font-weight-regular);
    font-size: 12px;
    color: var(--color-nero);

    @include breakpointMin('md') {
      font-size: 15px;
    }
  }

  &.size-sm {
    gap: 4px;

    @include breakpointMin('md') {
      gap: 5px;
    }

    .circle {
      width: 16px;
      height: 16px;

      @include breakpointMin('md') {
        width: 20px;
        height: 20px;
      }
    }

    .multi {
      width: 16px;
      height: 16px;

      @include breakpointMin('md') {
        width: 20px;
        height: 20px;
      }
    }

    input:checked + .circle:before,
    a.checked .circle:before {
      font-size: 10px;
      top: -2px;
      left: 3px;

      @include breakpointMin('md') {
        font-size: 13px;
        top: 1px;
        left: 4px;
      }
    }

    input:checked + .multi li:nth-child(1):before,
    a.checked .multi li:nth-child(1):before {
      font-size: 10px;
      top: -2px;
      left: 3px;

      @include breakpointMin('md') {
        font-size: 13px;
        top: 1px;
        left: 4px;
      }
    }
  }

  &.size-lg {
    gap: 11px;
    padding: 0px 7px;

    .circle {
      width: 27px;
      height: 27px;
    }

    .multi {
      width: 27px;
      height: 27px;
    }

    input:checked + .circle:before,
    a.checked .circle:before {
      font-size: 19px;
      top: 5px;
      left: 4px;
    }

    input:checked + .multi li:nth-child(1):before,
    a.checked .multi li:nth-child(1):before {
      font-size: 19px;
      top: 5px;
      left: 4px;
    }
  }
}
